<template>
  <div :class="['check-radio']">
    <div :style="{}" :class="['radio-container']">
      <!-- 前置内容 -->
      <span class="radio__prefix">
        <slot name="prefix"> </slot>
      </span>

      <!-- 自定义后置 -->
      <div class="radio__custom__suffix" v-if="$slots.custom_suffix">
      <!-- <div class="radio__custom__suffix"> -->
        <slot name="custom_suffix"> </slot>
        <!-- <div class="bu-radio">
          <label> 
              <span :check="true"></span>
              <span>air</span>
          </label>
        </div> -->
      </div>
    </div>
  </div>
</template>
    
    <script>
export default {
  inheritAttrs: false,
};
</script>
    
<style lang="scss" scoped >
.check-radio {
  height: 60px;
  & /deep/.el-radio {
    margin-right: 10px;
  }
}
.radio-container {
  font-size: 15px;
  padding-left: 20px;
  position: relative;
  height: 100%;
  background-color: #577ec7;
  border-radius: 30px;
  display: flex;

  .radio__prefix {
    color: #fff;
    // height:100%;
    text-align: center;
    line-height: 60px;
    & > * {
      margin-right: 10px;
    }
  }
  .radio__suffix {
    padding: 10px;
    // line-height: 40px;
  }
  .radio__suffix__text {
    background-color: rgb(137, 164, 215);
    padding: 10px 30px;
    border-radius: 20px;
    color: #fff;
  }
  .radio__custom__suffix {
    padding: 10px;
    line-height: 40px;
    color: white;

  }
}
</style>


// WEBPACK FOOTER //
// src/components/reception/checkPrice/components/CheckFrame.vue